export default {
  items: [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  }, {
    name: 'Campos',
    url: '/registrations/index',
    icon: 'icon-puzzle',
    auth: [],
    children: [
    {
      name: 'Inscrições',
      url: '/registrations/index',
      icon: 'fa fa-user-o'
    }, {
      name: 'Distribuição',
      url: '/distribution/index',
      icon: 'fa fa-random'
    }]
  }, {
    divider: true
  }, {
    name: 'Famílias',
    url: '/families/index',
    icon: 'fa fa-users'
  }, {
    name: 'Pessoas',
    url: '/familymembers/index',
    icon: 'fa fa-user'
  }, {
    name: 'Quotas',
    url: '/fees/index',
    icon: 'fa fa-money'
  }, {
    name: 'Histórico',
    url: '/history',
    icon: 'fa fa-history'
  }, {
    name: 'Casos',
    url: '/redcases',
    icon: 'fa fa-exclamation-triangle'
  }, {
    divider: true
  }, {
    name: 'Emails',
    url: '/email',
    icon: 'icon-puzzle',
    auth: [],
      children: [{
        name: 'Campanhas',
        url: '/email/campaigns',
        icon: 'fa fa-envelope'
      }, {
      name: 'Templates',
      url: '/email/templates',
      icon: 'fa fa-cubes'
    }]
  }, {
    name: 'Configurações',
    url: '/activities',
    icon: 'icon-puzzle',
    auth: [],
    children: [
    {
      name: 'Actividades',
      url: '/activities',
      icon: 'fa fa-cubes'
    }, {
      name: 'Subactividades',
      url: '/subactivities',
      icon: 'fa fa-cube'
    }, {
      name: 'Tipos de sócio',
      url: '/membershiptypes',
      icon: 'fa fa-gear'
    }, {
      name: 'Escalões',
      url: '/familymembertypes',
      icon: 'fa fa-gear'
    }, {
      name: 'Regiões',
      url: '/regions',
      icon: 'fa fa-gear'
    }, {
      name: 'Códigos Postais',
      url: '/zipcodes',
      icon: 'fa fa-gear'
    }, {
      name: 'Definições',
      url: '/settings',
      icon: 'fa fa-gear'
    }]
  }, {
    divider: true
  }, {
    name: 'Utilizadores',
    url: '/users',
    icon: 'icon-user'
  }]
}
